import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiModal(theme: Theme): Components['MuiModal'] {
  return {
    styleOverrides: {
      root: {
        zIndex: theme.zIndex.modal,
      },
    },
  };
}
